import { render, staticRenderFns } from "./authRestriction.vue?vue&type=template&id=ff7c69ac&scoped=true"
import script from "./authRestriction.vue?vue&type=script&lang=js"
export * from "./authRestriction.vue?vue&type=script&lang=js"
import style0 from "./authRestriction.vue?vue&type=style&index=0&id=ff7c69ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7c69ac",
  null
  
)

export default component.exports